module.exports = __webpack_public_path__ + "static/media/debt-funds.4543bfae.svg";